import React from "react";

const CustomLoader = ({ source = "stripe", handleLoad, loading }) => {
  return (
    <div className="custom-loader">
      <div className="loader-card">
        {loading ? (
          <>
            <h3>Retrieving data from {source}</h3>
            <p className="p2">
              Please wait while we collect data from {source}. <br />
              This may take a few seconds
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 100 100"
              enableBackground="new 0 0 0 0"
              xmlSpace="preserve"
              width={100}
              height={100}
              className="!filter-none"
            >
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stop-color="var(--gradient-left)" />
                  <stop offset="100%" stop-color="var(--gradient-right)" />
                </linearGradient>
              </defs>
              <circle fill="url(#gradient)" stroke="none" cx="30" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.1"
                />
              </circle>
              <circle fill="url(#gradient)" stroke="none" cx="50" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.2"
                />
              </circle>
              <circle fill="url(#gradient)" stroke="none" cx="70" cy="50" r="6">
                <animate
                  attributeName="opacity"
                  dur="1s"
                  values="0;1;0"
                  repeatCount="indefinite"
                  begin="0.3"
                />
              </circle>
            </svg>
          </>
        ) : (
          <>
            <h3>Retrieve data from {source}</h3>
            <p className="p2">
              Click the button below to retrieve data from {source}.<br /> This
              may take a few seconds.
            </p>
            <button data-button-type="primary" onClick={handleLoad}>
              Retrieve data
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CustomLoader;
